const initialState = {};

const getStartedV2 = (state = initialState, action) => {
  switch (action.type) {
    case 'TEMPLATE':
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default getStartedV2;
